export default class LabResult {
    constructor(type, result, rawResult, resultStatus, mnemonic, date, messageId, facilityNumber) {
        this.type = type;
        this.result = result;
        this.rawResult = rawResult;
        this.date = date;
        this.resultStatus = resultStatus;
        this.mnemonic = mnemonic;
        this.messageId = messageId;
        this.facilityNumber = facilityNumber;
    }
}
